import type { NextRouter } from "next/router"
import React from "react"

import type { Routing } from "@/lib/routing"

export const RoutingContext = React.createContext<Routing.ContextData>(
  undefined as unknown as NextRouter
)
